import { Tag } from "primereact/tag";
import { classNames } from "primereact/utils";

import styles from "./tipo-obra-tag.module.scss";
import type { TipoObraTagProps } from "./types-tipo-obra-tag";

export function TipoObraTagView({
  tipo,
  size = "md",
  tooltip,
  className,
  ...rest
}: TipoObraTagProps) {
  return (
    <Tag
      className={classNames(styles.tag, size === "sm" && "p-tag-sm", className)}
      data-tipo={tipo}
      data-pr-tooltip={tooltip}
      {...rest}
    >
      {tipo}
    </Tag>
  );
}
